module.exports = __webpack_public_path__ + "static/media/NagamasWidth.4a7ca7a7.png";